import useQuery from 'hooks/useQuery';
import { CuredApiPaths, GuardrailType } from 'models/enums';

import QueryKeys from './keys';

export type AIGuardrailRow = {
    id: number;
    guardrail_name: string;
    feature: string;
    guardrail_type: GuardrailType;
    system_prompt: string;
    error_message: string;
    sort_order: number | null;
    is_enabled: boolean;
    last_modified_by_user_id: string | null;
    created_timestamp: string;
    last_modified_timestamp: string;
};

const useGetGuardrailsList = () => useQuery<AIGuardrailRow[]>(QueryKeys.AI_GUARDRAILS, CuredApiPaths.AI_GUARDRAILS);

export default useGetGuardrailsList;
